const { connect } = require('react-redux');
const { context } = require('app-context');
const ClassDetailPage = require('../components/ClassDetailPage');
const withPropTypeDependencies = require('utils/withPropTypeDependencies');
const { analyticsTemplates } = require('utils/analytics');

const selectors = context.selectors.all;
const actions = context.actions;

const internals = {};

const ClassDetailPageContainer = connect(
    (state, { match: { params } }) => {

        const classDetails = selectors.getGroup_forGroupDetail_withUserSearchResults(state, params.id);
        const classRecord = classDetails?.class;
        const groupRoleGroups = classRecord
            ? selectors.getUsedRoleGroups_byGroupId(state, params.id)
            : [];
        const availableRoleGroups = groupRoleGroups.length
            ? groupRoleGroups
            : selectors.getSchoolUsedRoleGroups(state);
        const selectedRoleGroupFilter = selectors.getRoleGroupFilter(state, 'groups');
        const activeRoleGroupFilter = availableRoleGroups.find(({ name }) => name === selectedRoleGroupFilter) || 'all';

        return {
            roleGroupFilter: activeRoleGroupFilter.name || activeRoleGroupFilter,
            availableRoleGroups,
            activeRoleGroupFilter,
            classDetails,
            classSearchCriteria: selectors.getCriteria_forClassSearch(state, params.id),
            showLoadMore: selectors.getShowLoadMore_forClassSearch(state, params.id),
            showJoin: selectors.getCanJoinClass(state, params.id),
            classSearchText: selectors.getClassSearchTextById(state, params.id),
            role: selectors.getCurrentUserRole(state),
            isParent: selectors.isParentPermission(state)
        };
    },
    {
        onClickJoin: actions.classes.join,
        onClickLeave: actions.classes.leave,
        setClassSearchText: actions.classes.setSearchText,
        resolveInitialClassmates: (classId) => async (dispatch) => {

            await dispatch(actions.dataFetching.fetchClassUserSearchResults.firstPage({
                classId,
                allByMatches: true,
                preserveExistingResults: true
            }));
            dispatch(actions.app.setShouldRefreshSearch({ group: false }));
        },
        onClickLoadMore: (classId) => actions.dataFetching.fetchClassUserSearchResults.nextPage({ classId }),
        onSubmitSearch: (...args) => (dispatch) => internals.onSubmitSearch(...args)(dispatch),
        rememberScroll: () => (dispatch) => {

            return dispatch(actions.app.rememberScroll({ type: 'group' }));
        },
        restoreScroll: () => (dispatch) => {

            return dispatch(actions.app.restoreScroll({ type: 'group' }));
        },
        setRoleGroupFilter: (val, groupId, groupSearchVal) => (dispatch) => {

            const searchObj = {
                classId: groupId,
                ...(groupSearchVal ? { name: groupSearchVal } : {}),
                ...(val && val !== 'all' ? { contextFilter: val } : {})
            };

            dispatch(actions.app.setRoleGroupFilter({ groups: val }));

            return internals.onSubmitSearch(searchObj)(dispatch);
        }
    }
)(withPropTypeDependencies(ClassDetailPage));

ClassDetailPageContainer.dependencyPropTypes = ClassDetailPage.propTypes;

module.exports = ClassDetailPageContainer;

internals.filterOutEmpty = (obj) => {

    const { isBool } = internals;

    return Object.keys(obj)
        .filter((key) => {

            const value = obj[key];

            if (Array.isArray(value)) {
                return !!value.length;
            }

            return isBool(value) || !!value;
        })
        .reduce((collector, key) => {

            collector[key] = obj[key];
            return collector;
        }, {});
};

internals.isBool = (maybeBool) => {

    if (String(maybeBool) === 'true' || String(maybeBool) === 'false') {
        return true;
    }

    return false;
};

internals.onSubmitSearch = (criteria) => (dispatch) => {

    const filteredCriteria = internals.filterOutEmpty(criteria);
    const searchKeys = Object.keys(filteredCriteria);
    const nonDefaultSearchKeys = searchKeys.filter((key) => !['classId', 'contextFilter'].includes(key));
    const shouldUseSearchDefaults = typeof filteredCriteria.classId !== 'undefined' && nonDefaultSearchKeys.length === 0;

    analyticsTemplates.buttons('submit peers search', `class details: search submit ${searchKeys.length ? searchKeys : 'empty'}`);

    if (shouldUseSearchDefaults) {
        return dispatch(actions.dataFetching.fetchClassUserSearchResults.firstPage({
            classId: filteredCriteria.classId,
            allByMatches: true
        }));
    }

    const { interests, ...others } = filteredCriteria;

    const search = { ...others };

    if (interests) {
        search.interests = interests.map(({ id }) => id);
    }

    return dispatch(actions.dataFetching.fetchClassUserSearchResults.firstPage(search));
};
